<form *ngIf="form" [formGroup]="form" class="row">
    <mat-form-field>
        <mat-label>Comune</mat-label>
        <comune-picker formControlName="comune"></comune-picker>
    </mat-form-field>
</form>